import Splide from '@splidejs/splide';
import { assignRotateVars } from './inc/helpers';

export function slidersInit() {
    // init all sliders
    const $linkCardSliders = document.querySelectorAll('.slider-link-cards');
    if ( $linkCardSliders.length > 0 ) {
        sliderLinkCards();
        assignRotateVars('.slider-link-cards .splide__slide'); // assign hover vars to all instances
    }

    const $itinerariesSliders = document.querySelectorAll('.slider-itineraries, .slider-blog');
    if ( $itinerariesSliders.length > 0 ) {
        sliderItinerariesCards();
        assignRotateVars('.slider-itineraries .splide__slide'); // assign hover vars to all instances
    }

    const $pressSliders = document.querySelectorAll('.slider-press');
    if ( $pressSliders.length > 0 ) {
        sliderPressCards();
        assignRotateVars('.slider-press .splide__slide'); // assign hover vars to all instances
    }
    
}



// ==================== link cards ====================
function sliderLinkCards() {
    const $sliders = document.querySelectorAll('.slider-link-cards');

    $sliders?.forEach($slider => {
        var splide = new Splide($slider, {
            type: 'slide',
            // fixedWidth: 338,
            gap: '1rem',
            perPage: 3,
            pagination: false,
            arrows: false,
            breakpoints: {
                900: {
                    perPage: 2,
                },
                500: {
                    perPage: 1,
                },
            },
        });

        // ===== custom prev/next =====
        sliderPrevNextArrows($slider, splide);
    });
}


// ==================== itineraries cards ====================
function sliderItinerariesCards() {
    const $sliders = document.querySelectorAll('.slider-itineraries, .slider-blog');

    $sliders?.forEach($slider => {
        var splide = new Splide($slider, {
            type: 'slide',
            fixedWidth: 340,
            gap: '1.5rem',
            perMove: 4,
            pagination: false,
            arrows: false,
            breakpoints: {
                1480: {
                    perMove: 3,
                },
                900: {
                    fixedWidth: 290,
                    perMove: 2,
                },
                760: {
                    fixedWidth: 240,
                    perMove: 1,
                },
            },
        });

        // ===== custom prev/next =====
        sliderPrevNextArrows($slider, splide);
    });
}


// ==================== press cards ====================
function sliderPressCards() {
    const $sliders = document.querySelectorAll('.slider-press');

    $sliders?.forEach($slider => {
        var splide = new Splide($slider, {
            type: 'slide',
            fixedWidth: 340,
            gap: '1.5rem',
            perMove: 4,
            pagination: false,
            arrows: false,
            breakpoints: {
                1480: {
                    perMove: 3,
                },
                900: {
                    fixedWidth: 290,
                    perMove: 2,
                },
                760: {
                    fixedWidth: 240,
                    perMove: 1,
                },
            },
        });

        // ===== custom prev/next =====
        sliderPrevNextArrows($slider, splide);
    });
}



// ========== prev/next arrows ==========
function sliderPrevNextArrows($sliderEl, splide) {
    if ( !$sliderEl ) return;

    const $thisComp = $sliderEl.closest('.component');
    const $prevArrow = $thisComp.querySelector('.slider-arrow--prev');
    const $nextArrow = $thisComp.querySelector('.slider-arrow--next');

    function setArrowDisabled($arrow, isDisabled) {
        if ( !$arrow ) return;

        $arrow.classList.toggle('slider-arrow--disabled', isDisabled);
        $arrow.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    };

    function updateArrows(destIndex) {
        const index = typeof destIndex === 'number' ? destIndex : splide.index;
        const end = splide.Components.Controller.getEnd();

        setArrowDisabled($prevArrow, index <= 0);
        setArrowDisabled($nextArrow, index >= end);
    };

    $prevArrow?.addEventListener('click', () => {
        if ( $prevArrow.getAttribute('aria-disabled') === 'true' ) return;
        splide.go('<');
    });

    $nextArrow?.addEventListener('click', () => {
        if ( $nextArrow.getAttribute('aria-disabled') === 'true' ) return;
        splide.go('>');
    });

    splide.on('move', (newIndex) => updateArrows(newIndex));
    splide.on('mounted moved updated resized', updateArrows);
    splide.mount();
}

